var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4999 4.32307C18.1182 4.96071 15.6334 5.68004 12.7714 4.53524C9.39748 3.18568 6.64537 4.72101 4.99993 5.83348V14.7766C5.69503 14.3756 6.53676 13.9949 7.5723 13.7844C9.07954 13.4779 10.935 13.5433 13.2871 14.3274C16.8521 15.5157 18.9032 14.0492 19.4999 13.5158V4.32307ZM19.5292 2.61469C20.134 2.25056 20.9999 2.64882 20.9999 3.43889V13.7544C20.9999 13.9691 20.9269 14.2071 20.7441 14.3986C20.2702 14.8953 17.5978 17.3454 12.8128 15.7504C10.6699 15.0361 9.08274 15.008 7.87119 15.2543C6.65567 15.5015 5.75557 16.0367 4.98672 16.5593C4.36223 16.9839 3.49993 16.5457 3.49993 15.7735V5.54335C3.49993 5.23839 3.64622 4.9445 3.90769 4.76345C5.55055 3.62587 9.00977 1.41505 13.3285 3.14253C16.2403 4.30726 18.6886 3.12072 19.5292 2.61469Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.25C6 4.2165 5.2165 5 4.25 5C3.2835 5 2.5 4.2165 2.5 3.25C2.5 2.2835 3.2835 1.5 4.25 1.5C5.2165 1.5 6 2.2835 6 3.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24992 1.78888C4.66414 1.78888 4.99992 2.12467 4.99992 2.53888L4.99993 21.25C4.99993 21.6642 4.66414 22 4.24993 22C3.83571 22 3.49993 21.6642 3.49993 21.25L3.49992 2.53888C3.49992 2.12467 3.83571 1.78888 4.24992 1.78888Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.63da48aa93303915dc21adf6d5613190.svg";
export { ForwardRef as ReactComponent };